/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Reverse_Eleven_FramesInputs */



/**
* | output |
* | --- |
* | "Go back eleven frames in the video" |
*
* @param {Shortcut_Keys_Desc_Reverse_Eleven_FramesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_reverse_eleven_frames = /** @type {((inputs?: Shortcut_Keys_Desc_Reverse_Eleven_FramesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Reverse_Eleven_FramesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Go back eleven frames in the video")
	if (locale === "de") return /** @type {LocalizedString} */ ("Go back eleven frames in the video")
	if (locale === "it") return /** @type {LocalizedString} */ ("Go back eleven frames in the video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Go back eleven frames in the video")
	if (locale === "es") return /** @type {LocalizedString} */ ("Go back eleven frames in the video")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Go back eleven frames in the video")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Go back eleven frames in the video")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Go back eleven frames in the video")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Go back eleven frames in the video")
	return /** @type {LocalizedString} */ ("Go back eleven frames in the video")
});